import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMethodList, manualDisputePayIn, payInList, payInOutExcel, payinPush, returnOrderStatus } from "@/api/payment";
import infoList from "@/mixins/infoList";
import { formatTimeToStr } from "@/utils/date";
import { refundRisk } from "@/api/risk";
import { getDict } from "@/utils/dictionary";
export default {
  name: "Order",
  mixins: [infoList],
  data: function data() {
    return {
      zeroTime: null,
      currentTime: null,
      orderStatus: "all",
      orderStatusObj: {},
      methodList: [],
      goBankAmountVisble: false,
      goBankAmountData: {
        OrderId: "",
        Amount: 0
      },
      manualChargebackVisible: false,
      manualChargebackData: {
        id: "",
        status: 1
      },
      manualChargebackStatusOptions: [{
        label: "Received",
        value: 1
      }, {
        label: "Won",
        value: 2
      }, {
        label: "Lose",
        value: 3
      }],
      WhetherNotifySearch: [{
        lable: "true",
        value: 0
      }, {
        lable: "false",
        value: 1
      }, {
        lable: "",
        value: -1
      }],
      Notify: "",
      listApi: payInList,
      countryList: [],
      disputeStatus: [],
      disputeStatusSelected: -1,
      disputeCheckStatus: [],
      disputeCheckStatusSelected: -1,
      fraudStatus: [],
      fraudStatusSelected: -1,
      riskGrade: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchInfo.notifyOk = -1;
            _this.searchInfo.disputeStatus = -1;
            _this.searchInfo.disputeCheckStatus = -1;
            _this.searchInfo.fraudStatus = -1;
            _context.next = 1;
            return _this.initPage();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initPage: function initPage() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.currentTime = formatTimeToStr(new Date());
              _this2.zeroTime = formatTimeToStr(new Date() - 604800000);
              _this2.formatTimeOne(_this2.zeroTime, "start");
              _this2.formatTimeOne(_this2.currentTime, "end");
              _context2.next = 1;
              return _this2.getPayMethodList();
            case 1:
              _context2.next = 2;
              return _this2.getOrderStatus();
            case 2:
              _context2.next = 3;
              return _this2.getDictData();
            case 3:
              _context2.next = 4;
              return _this2.getTableData();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getDictData: function getDictData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _t = [{
                label: "All",
                value: -1
              }];
              _t2 = _toConsumableArray;
              _context3.next = 1;
              return getDict("DisputeCheckStatus");
            case 1:
              _this3.disputeCheckStatus = _t.concat.call(_t, _t2(_context3.sent)).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  value: Number(item.value)
                });
              });
              _t3 = [{
                label: "All",
                value: -1
              }];
              _t4 = _toConsumableArray;
              _context3.next = 2;
              return getDict("FraudStatus");
            case 2:
              _this3.fraudStatus = _t3.concat.call(_t3, _t4(_context3.sent)).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  value: Number(item.value)
                });
              });
              _context3.next = 3;
              return getDict("country");
            case 3:
              _this3.countryList = _context3.sent;
              _t5 = [{
                label: "All",
                value: -1
              }];
              _t6 = _toConsumableArray;
              _context3.next = 4;
              return getDict("disputeStatus");
            case 4:
              _this3.disputeStatus = _t5.concat.call(_t5, _t6(_context3.sent));
              _t7 = [{
                label: "All",
                value: -1
              }];
              _t8 = _toConsumableArray;
              _context3.next = 5;
              return getDict("RiskGrade");
            case 5:
              _this3.riskGrade = _t7.concat.call(_t7, _t8(_context3.sent));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getOrderStatus: function getOrderStatus() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return returnOrderStatus();
            case 1:
              res = _context4.sent;
              if (res.code === 0) {
                _this4.orderStatusObj = res.data;
                _this4.searchInfo.OrderStatus = _this4.searchOption(_this4.orderStatusObj, _this4.orderStatus);
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getPayMethodList: function getPayMethodList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return getMethodList();
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this5.methodList = res.data;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    pushMessage: function pushMessage(id) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return payinPush({
                OrderId: id
              });
            case 1:
              res = _context6.sent;
              if (res.code === 0) {
                _this6.$message.success(res.msg);
              }
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    canShowManualChargeback: function canShowManualChargeback(row) {
      var disputeStatus = Number(row.DisputeStatus === undefined ? row.dispute_status : row.DisputeStatus);
      return row.Status === "success" && disputeStatus !== 2 && disputeStatus !== 3;
    },
    openManualChargeback: function openManualChargeback(row) {
      this.manualChargebackData.id = row.Id;
      this.manualChargebackData.status = 1;
      this.manualChargebackVisible = true;
    },
    confirmManualChargeback: function confirmManualChargeback() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (_this7.manualChargebackData.id) {
                _context7.next = 1;
                break;
              }
              _this7.$message.error("Id\u4E0D\u80FD\u4E3A\u7A7A");
              return _context7.abrupt("return");
            case 1:
              _context7.next = 2;
              return manualDisputePayIn({
                colaPayIds: [_this7.manualChargebackData.id],
                status: Number(_this7.manualChargebackData.status)
              });
            case 2:
              res = _context7.sent;
              if (!(res.code === 0)) {
                _context7.next = 4;
                break;
              }
              _context7.next = 3;
              return _this7.getTableData();
            case 3:
              _this7.$message.success(res.msg);
              _this7.manualChargebackVisible = false;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    clearManualChargeback: function clearManualChargeback() {
      this.manualChargebackData.id = "";
      this.manualChargebackData.status = 1;
    },
    goBankAmount: function goBankAmount(list) {
      this.goBankAmountData.Amount = list.Amount;
      this.goBankAmountData.OrderId = list.Id;
      this.goBankAmountVisble = true;
    },
    goBankAmountConfirm: function goBankAmountConfirm() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var amount, res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              amount = parseFloat(_this8.goBankAmountData.Amount);
              _context8.next = 1;
              return refundRisk({
                orderId: _this8.goBankAmountData.OrderId,
                amount: amount
              });
            case 1:
              res = _context8.sent;
              if (!(res.code === 0)) {
                _context8.next = 3;
                break;
              }
              _context8.next = 2;
              return _this8.getTableData();
            case 2:
              _this8.$message.success(res.msg);
              _this8.goBankAmountVisble = false;
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    clearGoBankAmountVisble: function clearGoBankAmountVisble() {
      this.goBankAmountData.Amount = 0;
      this.goBankAmountData.OrderId = "";
    },
    payInExcel: function payInExcel() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return payInOutExcel(_this9.searchInfo);
            case 1:
              res = _context9.sent;
              if (res.code === 0) _this9.$message.success(res.data);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getDisputeStatusLabel: function getDisputeStatusLabel(value) {
      var item = this.disputeStatus.find(function (d) {
        return d.value === value;
      });
      return item ? item.label : value;
    },
    getRiskGradeLabel: function getRiskGradeLabel(value) {
      var item = this.riskGrade.find(function (r) {
        return r.value === value;
      });
      return item ? item.label : value;
    }
  }
};